<div class="container" style="margin-top: 20px">
  <div class="col-sm">
    <div class="mx-2 mb-4">
        <div class="row mt-1" style="padding-top:15px"  >
            <div class="col-sm-12" id="search-pill-container">
              <select [(ngModel)]="devicesSelected" (change)="onChangeSelect($event.target.value)">
                <option *ngFor="let c of devices" [ngValue]="c.id">{{c.name}}</option>
              </select>
              <label class="checkbox-inline">
                <span i18n="annotations_component|@@assembled_by_tchek"><input type="checkbox" [(ngModel)]="isAssemblyByTchek" (change)="checkValue()" />Rassemblé par Tchek </span>
            </label>
           
            
            </div>
          </div>
    </div>
    <div class="row mt-4">
        <div class="col-sm">
          <h2 class="header-marg" data-toggle="tooltip" data-placement="left" title="Pour ajouter une photo dans cette section, il suffit d'ajouter un ROI sur une photo à l'aide du mode Editer du lecteur."><span i18n="detail|@@rois">Annotations</span><small class="text-muted"></small></h2>
          <div class="row">
           
            <div class="col-sm" >
              <!-- TODO: Redo this part, app-roi-list should handle its content if there is ROIs or not; detail component should just invoke it?-->
              <div class="table-responsive" *ngIf="rois.length > 0">
                  <!-- List Display -->
                  <table class="table table-striped table-hover table-sm">
                    <thead>
                      <tr>
                        <th scope="col"> </th>
                        <th scope="col" i18n="roilist|@@type_">Type</th>
                        <th scope="col" i18n="roilist|@@tchekid">TchekId</th>
                        <th scope="col" i18n="roilist|@@number">Nombre</th>
                        <th scope="col" i18n="roilist|@@created_by">Créé par</th>
                        <th scope="col" i18n="roilist|@@created_at">Création</th>
                        <th scope="col"> </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let roi of rois; let i = index" (click)="openRoiSlider(roi, $event)">
                        <td><input type="checkbox"></td>
                        <td>{{roi.type}}</td> <!-- slice with pipe : (roi.location | slice:0:20)-->
                        <td [ngClass]="{'text-muted':!roi.location}">{{roi.tchekId}}</td>
                        <td [ngClass]="{'text-muted':!roi.location}">{{roi.number}}</td>
                        <td class="text-muted">—</td>
                        <td>{{roi.createdAt | date:'medium'}}</td>
                        <td [ngClass]="{'text-muted':!roi.hasBeenUpdated}">{{roi.hasBeenUpdated?
                          (roi.updatedAt | date:'medium') : '—'}}</td>
                        <td>
                         
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                
                
                
               
            </div>
          </div>
        </div>
      </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/annotations/annotations.component.html